import Vue from 'vue'
import Vuex from 'vuex'
import common from 'gclife-common-front/lib/store'

// vuex State管理对象
const state = {
  dic: {},           // 字典
  branches: []       // 销售机构
}

// mutations事件， 由actions执行提交commit()
const mutations = {
  CHANG_DIC(state, v) { state.dic = v },
  CHANG_BRANCHES(state, v) { state.branches = v }
}

// actions提交
const actions = {
  changDic({commit}, v) { commit('CHANG_DIC', v) },
  changBranches({commit}, v) { commit('CHANG_BRANCHES', v) }
}

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common
  },
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js